import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const SelfHostChange: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('self_host_change');

  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <Toggle
      label={t('setting.shell.changeHost')}
      description={t('settings.shell.client.host_change.description')}
      value={settings.selfHostChange}
      onChange={(value: string) => {
        setSetting({
          alias: ESettingsAliases.SHELL_SELF_HOST_CHANGE,
          value: value ? '1' : '0',
        });
      }}
      variant="secondary"
      emptyBg
      disabled={!isAvailable}
      rightContent={!isAvailable ? <SettingsLock /> : undefined}
    />
  );
};
